import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Grid, Button } from "semantic-ui-react";
import { Field } from "formik";

import FormikSimpleTimeDropdown from "../../forms/time/FormikSimpleTimeDropdown.jsx";
import FormikSemanticDropdown from "../../forms/formik/FormikSemanticDropdown.jsx";

import { getActionsList } from "../../../state/reducers/schedules/scheduleConstants.js";

import { ROW_STATE } from "../../forms/formConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class ScheduleActionsItem extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    data: PropTypes.object,
    timezone: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    required: false,
    readOnly: false,
    disabled: false,
    timezone: "UTC"
  };

  // -- HANDLER -- //

  onEdit = () => {
    const { id, onEdit } = this.props;
    onEdit(id);
  };

  onDelete = () => {
    const { id, onDelete } = this.props;
    onDelete(id);
  };

  // -- RENDER -- //

  render() {
    const { id, readOnly, disabled, apiErrors, copy, data, timezone } =
      this.props;

    if (data.state === ROW_STATE.DELETE) {
      return null;
    }

    return (
      <Fragment>
        <Grid.Column>
          <Field
            name={`${id}.value`}
            // label={copy("schedule.actions.actions_dropdown.label")}
            placeholder={copy("schedule.actions.actions_dropdown.placeholder")}
            selection
            search
            options={getActionsList()}
            required={true}
            readOnly={readOnly}
            disabled={disabled}
            apiErrors={apiErrors}
            onChange={this.onEdit}
            component={FormikSemanticDropdown}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={`${id}.at`}
            // label={copy("schedule.actions.time_dropdown.label")}
            placeholder={copy("schedule.actions.time_dropdown.placeholder")}
            timezone={timezone}
            required={true}
            readOnly={readOnly}
            disabled={disabled}
            apiErrors={apiErrors}
            onChange={this.onEdit}
            component={FormikSimpleTimeDropdown}
          />
        </Grid.Column>
        <Grid.Column>
          {!readOnly && (
            <Button
              onClick={this.onDelete}
              disabled={disabled}
              icon="minus circle"
              size="small"
              floated="right"
            />
          )}
        </Grid.Column>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ScheduleActionsItem);
